'use client';

import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFoundCatch() {
  const { push } = useRouter();
  Sentry.addBreadcrumb({
    message: 'Page not found',
    category: 'NotFoundCatch',
    level: 'info',
  });

  useEffect(() => {
    push('/not-found');
  }, [push]);

  return null;
}
